module.exports = __webpack_public_path__ + "img/icon_empty.8d35c993.jpg";